import React, { useState } from "react";
import VerificationApprovalModal from "../../../common/VerificationApprovalModal/VerificationApprovalModal.jsx";
import greenTick from "../../../resources/icons/greenTick.svg";
import warningInfoIcon from "../../../resources/icons/warning-info.svg";
import revokedIcon from "../../../resources/icons/revoked-lottie-icon.svg";
import { formatDate } from "../../../utils/formatDate.jsx";

const VerificationApprovalsLongCard = (props) => {
  const {
    transaction_id,
    verifier_org_name,
    created_at,
    verification_cost,
    vc_status,
    onCheckboxChange,
    isChecked,
    handleConfirmAction,
    verifier_name,
    document_type,
    onClick,
    selectedApprovalStatus,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [issuerComments, setIssuerComments] = useState("");

  const handleReject = (event) => {
    event.stopPropagation();
    setActionType("Rejected");
    setIsModalOpen(true);
  };

  const handleAccept = (event) => {
    event.stopPropagation();
    setActionType("Approved");
    setIsModalOpen(true);
  };

  const handleModalConfirm = () => {
    handleConfirmAction(actionType, transaction_id, issuerComments);
    setIsModalOpen(false);
    setIssuerComments("");
  };

  const handleCardClick = (event) => {
    event.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  const handleCheckboxChange = (event) => {
    event.stopPropagation();
    onCheckboxChange(transaction_id, event.target.checked);
  };

  const getActionStatus = () => {
    if (selectedApprovalStatus === "Approved") {
      return (
        <p className="font-semibold" style={{ color: "#3538CD" }}>
          Approved
        </p>
      );
    }
    if (selectedApprovalStatus === "Rejected") {
      return (
        <p className="font-semibold" style={{ color: "#D94D20" }}>
          Rejected
        </p>
      );
    }

    // Default and Pending case: Show Accept and Reject buttons
    return (
      <>
        <button
          className="flex rounded-[8px] items-center justify-center gap-2 w-[10rem] h-[2.5rem] lg:w-[10rem] lg:px-0 bg-[#3538CD] text-white font-medium lg:font-semibold text-sm lg:text-md hover:bg-cfPrimaryDark transition duration-200 focus:outline-none"
          onClick={handleAccept}
        >
          <div>Approve</div>
        </button>
        <button
          className="flex rounded-[8px] items-center justify-center gap-2 w-[10rem] h-[2.5rem] lg:w-[10rem] lg:px-0 bg-white text-black font-medium lg:font-semibold text-sm lg:text-md border border-gray-800 hover:bg-gray-100 transition duration-200 focus:outline-none"
          onClick={handleReject}
        >
          <div>Reject</div>
        </button>
      </>
    );
  };

  return (
    <div
      className="flex bg-white items-center min-h-[5rem] border-b py-1 px-4 cursor-pointer "
      onClick={handleCardClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardClick(e);
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div
        className="flex w-[2.0%] justify-center items-center bg-white"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        role="button"
        tabIndex={0}
      >
        {selectedApprovalStatus !== "Approved" &&
          selectedApprovalStatus !== "Rejected" && (
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              className="w-5 h-5 border-2 border-gray-500 rounded-lg accent-blue-600 appearance-auto cursor-pointer"
              onClick={(e) => e.stopPropagation()}
            />
          )}
      </div>
      <div className="flex w-[14.29%] justify-center items-center cursor-pointer ">
        <p className="font-regular text-black text-[14px]">
          {verifier_name || "N/A"}
        </p>
      </div>
      <div className="flex w-[14.29%] justify-center text-center cursor-pointer ">
        <p className="font-regular text-black text-[14px]">
          {verifier_org_name || "N/A"}
        </p>
      </div>
      <div className="flex w-[14.29%] justify-center items-center cursor-pointer">
        <p className="font-regular text-black text-[14px]">
          {created_at ? formatDate(created_at) : "No date available"}
        </p>
      </div>
      <div className="flex w-[14.29%] justify-center items-center cursor-pointer">
        {vc_status === "Verified" ? (
          <img src={greenTick} alt="Verified" className="w-10 h-10" />
        ) : vc_status === "Revoked" ? (
          <img src={revokedIcon} alt="Not Verified" className="w-11 h-11" />
        ) : (
          <img src={warningInfoIcon} alt="Not Verified" className="w-11 h-11" />
        )}
      </div>

      <div className="flex w-[14.29%] justify-center items-center cursor-pointer">
        <p className="font-regular text-black text-[14px]">
          {verification_cost && parseFloat(verification_cost) !== 0
            ? `₹ ${(parseFloat(verification_cost) / 100).toFixed(2)}`
            : "Free of charge"}
        </p>
      </div>
      <div className="flex w-[14.29%] justify-center items-center cursor-pointer">
        <p className="font-regular text-black text-[14px]">
          {document_type || "N/A"}
        </p>
      </div>
      <div className="flex w-[14.29%] justify-center items-center space-x-4">
        {getActionStatus()}
      </div>

      {/* Confirmation Modal */}
      <VerificationApprovalModal
        isModalOpen={isModalOpen}
        toggleModal={setIsModalOpen}
        actionType={actionType}
        handleConfirmAction={handleModalConfirm}
        issuerComments={issuerComments}
        setIssuerComments={setIssuerComments}
        isLegacy={props.isLegacy}
        matchingVCs={props.matchingVCs}
        vcStatus={vc_status}
      />
    </div>
  );
};

export default VerificationApprovalsLongCard;
